import { memo } from "react";
import { equals, pick } from "ramda";
import { SubText } from "@base-ui";
import Row from "./Row";
import Headers from "./Headers";
import { Tr, Table } from "./graphAxisTable.styles";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default /*#__PURE__*/memo(function GraphAxisTable(props) {
  var data = props.data,
    columns = props.columns,
    sort = props.sort,
    updateSort = props.updateSort,
    remove = props.remove,
    disableInteraction = props.disableInteraction,
    drilldownLabel = props.drilldownLabel,
    drilldown = props.drilldown,
    defaultText = props.defaultText,
    tableCaption = props.tableCaption,
    style = props.style;
  var rows = data.map(function (entry, idx) {
    return /*#__PURE__*/_jsx(Tr, {
      "aria-rowindex": idx + 2,
      children: /*#__PURE__*/_jsx(Row, {
        entry: entry,
        remove: remove,
        drilldown: drilldown,
        drilldownLabel: drilldownLabel,
        disableInteraction: disableInteraction
      })
    }, entry.id);
  });
  var defaultMarkup = /*#__PURE__*/_jsx(SubText, {
    children: defaultText
  });
  return data.length > 0 ? /*#__PURE__*/_jsxs(Table, {
    style: style,
    "aria-rowcount": data.length + 1,
    "aria-colcount": "3",
    children: [/*#__PURE__*/_jsx("caption", {
      className: "hidden-styles",
      children: tableCaption
    }), /*#__PURE__*/_jsxs("tbody", {
      children: [/*#__PURE__*/_jsx(Headers, {
        columns: columns,
        sort: sort,
        updateSort: updateSort
      }), rows]
    })]
  }) : defaultMarkup;
}, function (prev, curr) {
  return equals(pick(["data", "disableInteraction", "sort"], prev), pick(["data", "disableInteraction", "sort"], curr));
});